var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2894_201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2894_201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5235,
    cy: 35.5244,
    r: 34,
    transform: "rotate(61.2319 35.5235 35.5244)",
    stroke: "#20ACE3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.376 41.3248L49.3747 41.3228C49.3741 41.3218 49.3736 41.3209 49.373 41.3199L45.1312 34.4811M49.376 41.3248L45.1312 34.4811M49.376 41.3248C49.4662 41.4706 49.4616 41.5778 49.4394 41.6399C49.4172 41.7017 49.3542 41.7841 49.1966 41.8268C49.1941 41.8275 49.1916 41.8282 49.1894 41.8288L41.7773 43.8116C41.4219 43.9066 40.9337 43.7019 40.7326 43.3744L40.7325 43.3743C40.6427 43.228 40.6479 43.1216 40.6701 43.0602C40.6925 42.9987 40.756 42.9162 40.915 42.8737L45.8949 41.5415L47.2211 41.1867L45.913 40.6417L22.2802 30.7952C22.0595 30.7032 21.9008 30.5583 21.8146 30.4186C21.7286 30.2792 21.7267 30.1718 21.7512 30.1038C21.7757 30.0357 21.8442 29.9577 21.9949 29.917C22.1461 29.8761 22.354 29.884 22.5747 29.9759L46.2075 39.8225L47.5157 40.3675L46.7567 39.144L43.9071 34.5496C43.9071 34.5496 43.907 34.5496 43.907 34.5496M49.376 41.3248L43.907 34.5496M45.1312 34.4811C44.9278 34.1531 44.4388 33.9508 44.0852 34.0472C43.9273 34.0902 43.8646 34.1727 43.8427 34.2343C43.8207 34.2959 43.8161 34.403 43.907 34.5496M45.1312 34.4811L43.907 34.5496M49.3618 41.3005C49.3624 41.3016 49.3633 41.3032 49.3644 41.3051C49.3629 41.3024 49.3618 41.3004 49.3611 41.2992L49.3618 41.3005Z",
    fill: "#20ACE3",
    stroke: "#20ACE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.80b243654bb02189cfd393869129c99c.svg";
export { ForwardRef as ReactComponent };